import {
  IFoodFieldsFragment,
  IRecipeIngredientFieldsFragment,
  IUserIngredientFieldsFragment
} from "app/gql/graphqlSchema";
import {NutritionSummary} from "app/food/NutritionSummary";
import {UnreachableCaseError} from "ts-essentials";
import {Tooltip} from "antd";
import {FoodTag} from "app/food/FoodTag";

interface IProps {
  ingredient: IRecipeIngredientFieldsFragment;
  className?: string;
}

export const FoodSummary = ({ingredient, className}: IProps) => {
  let food: IFoodFieldsFragment | IUserIngredientFieldsFragment;
  switch (ingredient.__typename) {
    case "ReferenceRecipeIngredient": {
      food = ingredient.food;
      break;
    }
    case "UserRecipeIngredient": {
      food = ingredient.userIngredient;
      break;
    }
    default: {
      throw new UnreachableCaseError(ingredient);
    }
  }
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="text-gray-700 text-md font-bold">
        <Tooltip title={food.descriptionEn}>{food.nameEn}</Tooltip> <FoodTag food={food} />
      </div>
      <div className="text-gray-400 text-xs">
        <NutritionSummary nutrition={food.nutrition} />, per 100g
      </div>
    </div>
  );
};

export const FoodName = ({ingredient, className}: IProps) => {
  let food: IFoodFieldsFragment | IUserIngredientFieldsFragment;

  switch (ingredient.__typename) {
    case "ReferenceRecipeIngredient": {
      food = ingredient.food;
      break;
    }
    case "UserRecipeIngredient": {
      food = ingredient.userIngredient;
      break;
    }
    default: {
      throw new UnreachableCaseError(ingredient);
    }
  }
  return <span className={className}>{food.nameEn}</span>;
};
